import { useRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { makeStyles } from 'beam/dist/styles'
import { msToHHMMSS } from 'beam/dist/utils/time'
import { SCROLL_ALIGNMENT_FRACTION } from '../MediaPlayer/helpers'

const useStyles = makeStyles(theme => ({
  timeMarker: props => ({
    position: 'absolute',
    marginLeft: theme.spacing(2),
    transition: props.isScrubbing ? '' : 'top 0.2s ease-out',
  }),
  currentTime: {
    height: theme.spacing(1.5),
    textAlign: 'left',
    color: theme.palette.grey[700],
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    transition: 'transform 0.2s ease-in-out',
    borderRadius: 4,
    padding: theme.spacing(0.5, 0.5, 0.5, 0),
  },
  bar: props => ({
    borderBottom: `solid 2px ${theme.palette.color.red[700]}`,
    marginTop: theme.spacing(-1),
    width: `${props.width + 6}px`, // the 6 is the overlay into the actual Timeline Panel
    height: 6,
  }),
  translate: {
    transform: 'translateY(-110%)',
  },
}))

const propTypes = {
  isZoomed: PropTypes.bool,
  isScrubbing: PropTypes.bool,
  completed: PropTypes.number,
  duration: PropTypes.number,
  width: PropTypes.number,
  containerRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
}

const TimeMarker = ({ isZoomed, isScrubbing, completed, duration, width, containerRef }) => {

  const labelRef = useRef()


  // After the label has enough room, it will flip to the top of the red bar
  const flipLabel = (duration, currentTime) => {
    if (containerRef.current && labelRef.current) {
      const msPerPixel = duration / containerRef.current.clientHeight
      const progressHeight = (currentTime * 1000) / msPerPixel
      if (progressHeight > labelRef.current.clientHeight) {
        return true
      }
    }

    return false
  }

  const classes = useStyles({ width, isScrubbing })
  const completedPercent = (completed / duration) * 100

  const top = `${isZoomed ? 100 / SCROLL_ALIGNMENT_FRACTION : completedPercent}%`

  return (
    <div className={classes.timeMarker} style={{ top }}>
      <div className={classes.bar} />
      <div
        className={classNames(classes.currentTime, {
          [`${classes.translate}`]: isZoomed || flipLabel(duration, completedPercent),
        })}
        ref={labelRef}
      >
        {msToHHMMSS(completed)}
      </div>
    </div>
  )
}

TimeMarker.propTypes = propTypes

export default TimeMarker
